import OCWidgetPage from "./OCWidgetPage";

const ShingleExplorerPage = () => (
  <OCWidgetPage
    title="Shingle Explorer"
    description="Browse Owens Corning® shingle product lines and colors on different house styles."
    metaDescription="Explore Owens Corning shingle colors and styles with our interactive shingle explorer tool."
  >
    <div
      className="oc_shingle_view"
      data-shingle="trudefinition-duration"
      data-view="house"
      data-layout="row"
      data-style="default"
    />
  </OCWidgetPage>
);

export default ShingleExplorerPage;
